import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { withRouter, useParams, useLocation } from 'react-router-dom';
import { LoginComponent } from 'components';
import { actions as userActions } from '../../store/user';
const { checkAdsaml, updateAdsamlDetails, ssoLogIn } = userActions;

const schema = {
  tenantId: {
    presence: { allowEmpty: false, message: 'is required' }
  }
};

const SsoLogin = () => {
  const dispatch = useDispatch();
  const [adSamlLoading, setAdSamlLoading] = useState(false);
  const [adSamlError, setAdSamlError] = useState(null);
  const { tenantId, contextId } = useParams();
  const location = useLocation();
  let adsamlDetails = {};

  useEffect(() => {
    if (tenantId && contextId) {
      adsamlDetails = {
        tenantId: tenantId,
        contextId: contextId,
        isSuccess: new URLSearchParams(location.search).get('isSuccess')
      };
      if (adsamlDetails.isSuccess === 'true') {
        adsamlDetails = {
          ...adsamlDetails,
          adsamlToken: new URLSearchParams(location.search).get('adsamlToken')
        };
        dispatch(updateAdsamlDetails(adsamlDetails));
        setAdSamlLoading(true);
        dispatch(ssoLogIn(adsamlDetails));
      } else {
        adsamlDetails = {
          ...adsamlDetails,
          isError: true,
          errorMsg: new URLSearchParams(location.search).get('message')
        };
        dispatch(updateAdsamlDetails(adsamlDetails));
        setAdSamlError(adsamlDetails.errorMsg);
      }
    }
  }, []);

  const isAdsamlEnabled = (event, values) => {
    event.preventDefault();
    dispatch(checkAdsaml(values.tenantId));
  };

  const getInputFields = () => [
    { name: 'tenantId', label: 'TenantID', type: 'text' }
  ];

  const getButtonGroup = () => [
    {
      title: 'Continue',
      action: (event, values) => isAdsamlEnabled(event, values),
      isSubmit: true
    }
  ];

  return (
    <LoginComponent
      title={'SSO Login'}
      subTitle={'Login as AZURE AD user'}
      inputFields={getInputFields()}
      buttonGroup={getButtonGroup()}
      adsamlLogin={{
        isEnabled: true,
        checkAdsaml: isAdsamlEnabled,
        isSamlLoading: adSamlLoading,
        error: adSamlError
      }}
      schema={schema}
    />
  );
};

export default withRouter(SsoLogin);
